"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 判断是否为有限数
 * @return {Boolean}
 */
var is_number_1 = require("./is-number");
function default_1(value) {
    return is_number_1.default(value) && isFinite(value);
}
exports.default = default_1;
//# sourceMappingURL=is-finite.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-finite.js
// module id = 1119
// module chunks = 37